const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-start-end",
        label: "작성일",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "선임일", "이수증", "작성일"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  작성일
    if (search.date) {
      conditions.push({ key: "created_at", operator: ">=", value: search.date.startDate });
      conditions.push({ key: "created_at", operator: "<", value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : "" });
    }

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "구분",
        key: "body.구분",
      },
      {
        name: "선임일",
        key: "body.선임일",
      },
      {
        name: "이름",
        key: "body.이름",
      },
      {
        name: "직급",
        key: "body.직급",
      },
      {
        name: "최근 교육이수일",
        key: "body.최근교육이수일",
        style: { minWidth: "120px" },
      },
      {
        name: "이수증",
        key: "body.이수증",
      },
      {
        name: "작성일",
        key: "created_at",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 1:
          return func.getContent(value).구분; // 구분
        case 2:
          return func.getContent(value).선임일; // 최초 선임일
        case 3:
          return func.getContent(value).이름; // 이름
        case 4:
          return func.getContent(value).직급; // 직급
        case 5:
          return func.getContent(value).최근교육이수일; // 최근 교육이수일
        case 6: {
          // 교육이수증
          const file = func.getContent(value).교육이수증;
          const fileList = [];
          if (Object.keys(file).length !== 0) {
            fileList.push(file);
          }
          return {
            type: "file",
            files: fileList,
          };
        }
        case 7:
          return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
